import * as React from "react";
import MultiSelect from "./MultiSelect";
import { SelectableOption } from "./MultiSelect";
import { AllOfAnyOf } from "../../../dtos/Tmd.dtos";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { ITmdState } from "../../../reducers";
import { bindActionCreators } from "redux";
import * as PersonnelActions from "../../../actions/personnel";
import { connect } from "react-redux";
import { SearchType } from "../../../actions/personnel";

interface IPersonnelSearchProps {
    title?: string;
    update?: (
        searchType: SearchType,
        tmdRolesAllOfAnyOf: AllOfAnyOf,
        tmdTrialsAllOfAnyOf: AllOfAnyOf,
        categoriesAllOfAnyOf: AllOfAnyOf,
        trialGroupsAllOfAnyOf: AllOfAnyOf
    ) => void;
    advancedSearchTMDRole: Dtos.PersonnelTmdRole[];
    advancedSearchTMDTrial: Dtos.PersonnelTmdTrial[];
    advancedSearchCategory: Dtos.PersonnelCategory[];
    advancedSearchTrialGroup: Dtos.PersonnelTrialGroup[];
    tmdRoleUpdate?: any;
    tmdTrialUpdate?: any;
    categoryUpdate?: any;
    trialGroupUpdate?: any;
    searchType: SearchType;
}

interface IPersonnelSearchState {
    TMDRolesAllOfAnyOf: AllOfAnyOf;
    TMDTrialsAllOfAnyOf: AllOfAnyOf;
    CategoriesAllOfAnyOf: AllOfAnyOf;
    TrialGroupsAllOfAnyOf: AllOfAnyOf;
}

class PersonnelsSearch extends React.PureComponent<
    IPersonnelSearchProps,
    IPersonnelSearchState
> {
    constructor(props: IPersonnelSearchProps) {
        super(props);

        this.state = {
            TMDRolesAllOfAnyOf: AllOfAnyOf.AllOf,
            TMDTrialsAllOfAnyOf: AllOfAnyOf.AllOf,
            CategoriesAllOfAnyOf: AllOfAnyOf.AllOf,
            TrialGroupsAllOfAnyOf: AllOfAnyOf.AllOf,
        };

        this.optionSelectedTMDRoles = this.optionSelectedTMDRoles.bind(this);
        this.optionSelectedTMDTrials = this.optionSelectedTMDTrials.bind(this);
        this.optionSelectedCategories =
            this.optionSelectedCategories.bind(this);
        this.optionSelectedTrialGroups =
            this.optionSelectedTrialGroups.bind(this);
    }

    updateState() {
        this.props.update(
            this.props.searchType,
            this.state.TMDRolesAllOfAnyOf,
            this.state.TMDTrialsAllOfAnyOf,
            this.state.CategoriesAllOfAnyOf,
            this.state.TrialGroupsAllOfAnyOf
        );
    }

    allOfAnyOf(allOfAnyOf: AllOfAnyOf, click: (update: AllOfAnyOf) => void) {
        return (
            <div className="row">
                <div className="col-md-12">
                    <span onClick={() => click(AllOfAnyOf.AllOf)}>
                        <input
                            type="radio"
                            checked={allOfAnyOf == AllOfAnyOf.AllOf}
                        />
                        <label className="ml-1 label">All of</label>
                    </span>
                    <span onClick={() => click(AllOfAnyOf.AnyOf)}>
                        <input
                            type="radio"
                            className="ml-2"
                            checked={allOfAnyOf == AllOfAnyOf.AnyOf}
                        />
                        <label className="ml-1 label">Any of</label>
                    </span>
                </div>
            </div>
        );
    }

    optionSelectedTMDRoles(option: SelectableOption) {
        const tmdRole = this.props.advancedSearchTMDRole.map((t) => {
            if (t.id == option.id) {
                return { ...option, selected: !option.selected };
            } else return t;
        });
        this.props.tmdRoleUpdate(tmdRole, this.props.searchType);
    }

    optionSelectedTMDTrials(option: SelectableOption) {
        const tmdTrial = this.props.advancedSearchTMDTrial.map((t) => {
            if (t.id == option.id) {
                return { ...option, selected: !option.selected };
            } else return t;
        });
        this.props.tmdTrialUpdate(tmdTrial, this.props.searchType);
    }

    optionSelectedCategories(option: SelectableOption) {
        const category = this.props.advancedSearchCategory.map((t) => {
            if (t.id == option.id && t.categoryType == option.categoryType) {
                return { ...option, selected: !option.selected };
            } else return t;
        });
        this.props.categoryUpdate(category, this.props.searchType);
    }

    optionSelectedTrialGroups(option: SelectableOption) {
        const trialGroup = this.props.advancedSearchTrialGroup.map((t) => {
            if (t.id == option.id) {
                return { ...option, selected: !option.selected };
            } else return t;
        });
        this.props.trialGroupUpdate(trialGroup, this.props.searchType);
    }

    render() {
        const { title } = this.props;

        return (
            <>
                {title ? (
                    <div className="col-md-12">
                        <h3 className="mt-3">{title}</h3>
                    </div>
                ) : (
                    <></>
                )}
                <div className="form-group row pt-0 pb-4 border-top-0">
                    <div className="col-md-6">
                        <div className="row bottom-0 border-top-0 pb-0 pt-4">
                            <label className="col-form-label col-sm-3">
                                TMD Roles
                            </label>
                            <div className="col-sm-9 generic-form-field generic-form-field">
                                {this.allOfAnyOf(
                                    this.state.TMDRolesAllOfAnyOf,
                                    (update) => {
                                        this.setState(
                                            { TMDRolesAllOfAnyOf: update },
                                            () => this.updateState()
                                        );
                                    }
                                )}
                                <MultiSelect
                                    selectableOptions={
                                        this.props.advancedSearchTMDRole
                                    }
                                    optionSelected={this.optionSelectedTMDRoles}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row bottom-0 border-top-0 pb-0 pt-4">
                            <label className="col-form-label col-sm-3">
                                TMD Trials
                            </label>
                            <div className="col-sm-9 generic-form-field generic-form-field">
                                {this.allOfAnyOf(
                                    this.state.TMDTrialsAllOfAnyOf,
                                    (update) => {
                                        this.setState(
                                            { TMDTrialsAllOfAnyOf: update },
                                            () => this.updateState()
                                        );
                                    }
                                )}
                                <MultiSelect
                                    selectableOptions={
                                        this.props.advancedSearchTMDTrial
                                    }
                                    optionSelected={
                                        this.optionSelectedTMDTrials
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row bottom-0 border-top-0 pb-0 pt-4">
                            <label className="col-form-label col-sm-3">
                                Categories
                            </label>
                            <div className="col-sm-9 generic-form-field">
                                {this.allOfAnyOf(
                                    this.state.CategoriesAllOfAnyOf,
                                    (update) => {
                                        this.setState(
                                            { CategoriesAllOfAnyOf: update },
                                            () => this.updateState()
                                        );
                                    }
                                )}
                                <MultiSelect
                                    selectableOptions={
                                        this.props.advancedSearchCategory
                                    }
                                    optionSelected={
                                        this.optionSelectedCategories
                                    }
                                    showCategoryTypes={true}
                                    categoryTypes={[
                                        "Membership type",
                                        "Professional discipline",
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row bottom-0 border-top-0 pb-0 pt-4">
                            <label className="col-form-label col-sm-3">
                                Trial Groups
                            </label>
                            <div className="col-sm-9 generic-form-field generic-form-field">
                                {this.allOfAnyOf(
                                    this.state.TrialGroupsAllOfAnyOf,
                                    (update) => {
                                        this.setState(
                                            { TrialGroupsAllOfAnyOf: update },
                                            () => this.updateState()
                                        );
                                    }
                                )}
                                <MultiSelect
                                    selectableOptions={
                                        this.props.advancedSearchTrialGroup
                                    }
                                    optionSelected={
                                        this.optionSelectedTrialGroups
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

interface IPersonnelsSearchActions {}

const mapStateToProps = (
    state: ITmdState,
    ownProps: IPersonnelSearchProps
): IPersonnelSearchProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        advancedSearchTMDRole: ownProps.advancedSearchTMDRole,
        advancedSearchTMDTrial: ownProps.advancedSearchTMDTrial,
        advancedSearchCategory: ownProps.advancedSearchCategory,
        advancedSearchTrialGroup: ownProps.advancedSearchTrialGroup,

        tmdRoleUpdate: ownProps.tmdRoleUpdate,
        tmdTrialUpdate: ownProps.tmdTrialUpdate,
        categoryUpdate: ownProps.categoryUpdate,
        trialGroupUpdate: ownProps.trialGroupUpdate,
        searchType: ownProps.searchType,
    };
};

const mapDispatchToProps = (dispatch): IPersonnelsSearchActions => {
    return {
        tmdRoleUpdate: bindActionCreators(
            PersonnelActions.TmdRoleUpdate,
            dispatch
        ),
        tmdTrialUpdate: bindActionCreators(
            PersonnelActions.TmdTrialUpdate,
            dispatch
        ),
        categoryUpdate: bindActionCreators(
            PersonnelActions.CategoryUpdate,
            dispatch
        ),
        trialGroupUpdate: bindActionCreators(
            PersonnelActions.TrialGroupUpdate,
            dispatch
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelsSearch);
